<cmps-wait-status *ngIf="hasPendingData"></cmps-wait-status>
<div *ngIf="!hasPendingData && data == null">
    {{ i18n._711_NO_DATA_AVAILABLE | translate }}
</div>
<div
    class="table-responsive"
    *ngIf="!hasPendingData && data != null"
>
    <table class="table table-striped table-sm table-bordered-no-cells">
        <thead class="thead-light">
            <tr>
                <th>{{ i18n._785_PERFORMER | translate }}</th>
                <th>{{ i18n._786_OPPORTUNITY_METRIC | translate }}</th>
                <th>{{ i18n._787_SUGGESTED_FOCUS | translate }}</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let i of data.items">
                <td>{{ i.name }}</td>
                <td>{{ i.metrics.length }}</td>
                <td>
                    <button
                        type="button"
                        class="cmps-btn-table"
                        role="link"
                        (click)="goToJournal()"
                        *ngIf="i.focus"
                    >
                        {{ i.focus.name }}
                    </button>
                </td>
            </tr>
        </tbody>
    </table>
</div>
